/**
 * Diretiva responsável por gerar um ícone para um determinado tipo de endereço eletrônico.
 */

angular.module("avlib").directive("avEAddressIcon", function(){
	return {
		template: require("!html-loader!./EAddressIconTemplate.html"),
		restrict: "E",
		scope: {
			eAddressType: '=',
		},
	};
});
